import React from 'react';
import { useSelector } from 'react-redux';
import classes from './Insights.module.scss';
import ConfigureViewHeader from 'components/home/views/configure-view/ConfigureViewHeader';
import TileContainer from '../insights/tiles/TileContainer';
import { CONFIGURE_VIEW } from 'constants/constants';

const Insights = () => {
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );

  return (
    <div
      className={classes['insights-container']}
      id='Insights'>
      <ConfigureViewHeader page={CONFIGURE_VIEW.insights} />
      {allInsightViews?.length > 0 && (
        <TileContainer page={CONFIGURE_VIEW.insights} />
      )}
    </div>
  );
};
export default Insights;
